import type { ReactNode } from "react"
import AdminHeader from "./AdminHeader"
import AdminSidebar from "./AdminSidebar"

type AdminLayoutProps = {
    children: ReactNode
}

export default function AdminLayout({ children }: AdminLayoutProps) {
    return (
        <div className="min-h-screen bg-slate-50 text-slate-900">
            <AdminHeader />

            <main className="mx-auto max-w-[1600px] px-4 py-8 lg:px-6">
                <div className="grid gap-6 lg:grid-cols-[260px_1fr]">
                    <AdminSidebar />
                    <section>{children}</section>
                </div>
            </main>
        </div>
    )
}